webpackJsonp([219147425318692],{

/***/ 815:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tutorials-examples-dining-philosophers-a0e39f21c11f6a62c5ab.js